import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { hashHistory } from 'react-router';
import Chat from 'material-ui/svg-icons/communication/forum';






class ChatWithCareGuideFooter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {
    }



    render() {

        const style = {
            labels:{
                fontFamily: "trueno-light",
                fontSize: "38px",
                color: "#828282",
            },
        }
        return (

            <div style={{textAlign: 'center', margin: '15px 0px 25px 0'}}>
                <div style={{marginBottom:'8px'}}>
                    <span style={style.label}>{this.props.Text}</span>
                </div>
                
                <RaisedButton fullWidth={true} label="Message a Care Guide" labelStyle={{fontSize:18}} primary={true} icon={<Chat />} onClick={()=> hashHistory.push('/message/0/view')} />

            </div>

        );
    }
};

export default ChatWithCareGuideFooter;




// WEBPACK FOOTER //
// ./src/Components/ChatWithCareGuideFooter.js